import React, { ReactNode } from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  onToggleSidebar: () => void;
  centerContent: ReactNode;
  rightActions?: ReactNode;
  leftActions?: ReactNode;
  onCenterClick?: () => void;
  centerClassName?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  onToggleSidebar,
  centerContent,
  rightActions,
  leftActions,
  onCenterClick,
  centerClassName = ''
}) => {
  return (
    <div className="page-header">
      <div className="page-header-left">
        <button className="page-header-menu-btn" onClick={onToggleSidebar}>
          ☰
        </button>
        {leftActions}
      </div>
      
      <div 
        className={`page-header-center ${centerClassName} ${onCenterClick ? 'clickable' : ''}`}
        onClick={onCenterClick}
      >
        {centerContent}
      </div>
      
      {rightActions && (
        <div className="page-header-actions">
          {rightActions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;

